var _path, _path2, _g, _path3, _path4, _g2, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrationGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 32,
    viewBox: "0 0 37 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4281 14.2962C24.3043 13.8425 24.125 13.4059 23.8941 12.9962L24.9331 10.8192C24.5437 10.344 24.1083 9.90855 23.6331 9.51922L21.4561 10.5582C21.0464 10.3273 20.6097 10.148 20.1561 10.0242L19.3481 7.74723C19.0481 7.71923 18.7481 7.68922 18.4401 7.68922C18.1364 7.68649 17.8329 7.70589 17.5321 7.74723L16.7241 10.0242C16.2712 10.1505 15.8349 10.3297 15.4241 10.5582L13.2471 9.51922C12.7716 9.90828 12.3361 10.3438 11.9471 10.8192L13.0011 12.9982C12.7709 13.4081 12.5919 13.8447 12.4681 14.2982L10.1911 15.1052C10.1611 15.4052 10.1331 15.7052 10.1331 16.0132C10.1303 16.3169 10.1497 16.6204 10.1911 16.9212L12.4681 17.7292C12.5917 18.1828 12.7707 18.6194 13.0011 19.0292L11.9631 21.2062C12.3518 21.6819 12.7873 22.1174 13.2631 22.5062L15.4401 21.4682C15.8499 21.6985 16.2865 21.8776 16.7401 22.0012L17.5481 24.2782C17.8481 24.3082 18.1481 24.3362 18.4561 24.3362C18.7597 24.3389 19.0632 24.3196 19.3641 24.2782L20.1721 22.0012C20.6256 21.8774 21.0621 21.6984 21.4721 21.4682L23.6491 22.5062C24.1245 22.1172 24.56 21.6817 24.9491 21.2062L23.9101 19.0292C24.1411 18.6196 24.3205 18.183 24.4441 17.7292L26.7211 16.9212C26.7501 16.6212 26.7791 16.3212 26.7791 16.0132C26.7818 15.7095 26.7624 15.4061 26.7211 15.1052L24.4441 14.2982L24.4281 14.2962ZM15.6631 16.1262C15.6629 16.6737 15.825 17.209 16.1291 17.6643C16.4331 18.1196 16.8653 18.4746 17.3711 18.6842C17.8769 18.8939 18.4334 18.9488 18.9705 18.8422C19.5075 18.7355 20.0008 18.4719 20.388 18.0848C20.7752 17.6978 21.0389 17.2046 21.1458 16.6676C21.2527 16.1306 21.1979 15.574 20.9885 15.0682C20.779 14.5623 20.4242 14.13 19.969 13.8258C19.5138 13.5216 18.9786 13.3592 18.4311 13.3592C17.6974 13.3598 16.9939 13.6515 16.4751 14.1702C15.9563 14.689 15.6636 15.3925 15.6631 16.1262Z",
    stroke: "#76808D",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2933",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 0,
    width: 17,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.605 0H18.605V16H34.605V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.605 31.5C27.1654 31.5 34.105 24.5604 34.105 16C34.105 7.43959 27.1654 0.5 18.605 0.5C10.0446 0.5 3.10498 7.43959 3.10498 16C3.10498 24.5604 10.0446 31.5 18.605 31.5Z",
    stroke: "#76808D"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1039 14.1841L34.1599 16.316L36.2109 14.1841",
    stroke: "#76808D",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2933",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 15,
    width: 17,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.60598 32H18.605L18.605 15.999L2.60598 15.999L2.60598 32Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.605 0.497999C10.0451 0.497999 3.106 7.43803 3.106 15.999C3.106 24.56 10.0451 31.5 18.605 31.5C27.1649 31.5 34.104 24.56 34.104 15.999C34.104 7.43803 27.1649 0.497999 18.605 0.497999Z",
    stroke: "#76808D"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.107 17.8159L3.051 15.6839L1 17.8159",
    stroke: "#76808D",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationGrey);
export default __webpack_public_path__ + "static/media/IntegrationGrey.494d86cba41efd8aa8d18a114dbefebf.svg";
export { ForwardRef as ReactComponent };